import apiService from "@/services/apiService";

const UserProfileService = {
  me: async () => {
    const response = await apiService.get('me');

    return response.data;
  },

  fetchTimezones: async () => {
    const response = await apiService.get('/timezones');
    return response.data;
  },

  fetchUserProfile: async () => {
    const response = await apiService.get(`/users/profile`);
    return response.data;
  },

  fetchManagedClubs: async () => {
    const response = await apiService.get('/users/managed_clubs');
    return response.data;
  },

  fetchUserAddresses: async () => {
    const response = await apiService.get('/users/addresses');
    return response.data;
  },

  fetchCountries: async () => {
    const response = await apiService.get('/countries');
    return response.data;
  },

  fetchRegions: async (countryId) => {
    const response = await apiService.get(`/countries/${countryId}/regions`);
    return response.data;
  },

  fetchCities: async (regionId) => {
    const response = await apiService.get(`/regions/${regionId}/cities`);
    return response.data;
  },

  updateUserProfilePreferences: async (userId, data) => {
    const response = await apiService.patch(`/users/update_profile_preferences`, data);
    return response.data
  },

  updateProfilePhoto: async (blobId) => {
    const response = await apiService.patch('/users/update_profile_photo', {
      update_profile_photo: { blob_id: blobId }
    });
    return response.data;
  },

  createAddress: async (addressData) => {
    const response = await apiService.post('/addresses', addressData);
    return response.data;
  },

  updateAddress: async (addressId, addressData) => {
    const response = await apiService.patch(`/addresses/${addressId}`, addressData);
    return response.data  
  },

  deleteAddress: async (addressId) => {
    const response = await apiService.delete(`/addresses/${addressId}`);
    return response.data;
  },

  setDefaultAddress: async (addressId) => {
    const response = await apiService.patch(`/addresses/${addressId}/set_default`);
    return response.data;
  }
};

export default UserProfileService;
